module.exports = __webpack_public_path__ + "img/slide12.229e10b8.png";